
import { useMemo, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faSyncAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import useUtils from '../../../utiles/useUtiles';
import Swal from 'sweetalert2';
import "./subscriber.scss";
import util from '../../../utiles/miniUtiles';
import { Switch } from '@mui/material';

// import ModalAddUser from '../../components/ModalAddUser';

const SubscriberContent = () => {

    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    const [usersList, setUsersList] = useState<any>({ count: 0, rows: [] });
    const [loading, setLoading] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<string>('');
    const [pagination, setPagination] = useState<any>({
        pageIndex: 0,
        pageSize: 5
    });

    useEffect(() => {
        fetchUsers();
    }, [pagination.pageIndex, pagination.pageSize]);


    // Reset account, show option on which stage to reset
    const alertActivateSubscriber = (account_id: number = 0) => {
        Swal.fire({
            title: 'Activate subscriber account',
            html: `<p>Activate a subscriber means that you will be with him in a meeting.</p>`,
            customClass: "swal2-radio-custom",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                console.log(result);
                activateSubscribeAccount(account_id);
            }
        });
    }

    // Columns for the table
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }: any) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'email',
                header: 'Email',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'status',
                header: 'Status',
                minSize: 50,
                maxSize: 120,
                Cell: ({ cell }) => {
                    switch (cell.getValue()) {
                        case 0:
                            return <span className="text-danger">Inactive</span>;
                        case 1:
                            return <span className="text-success">Active</span>;
                        case 3:
                            return <span className="text-info">Lock</span>;
                        default:
                            return <span className="text-warning">Unknown</span>;
                    }
                },
            },
            {
                accessorKey: 'actions1',
                header: '',
                minSize: 30,
                maxSize: 60,
                Cell: ({ cell }) => <div>
                    <Switch
                        checked={cell.row.original.status === 1}
                        onChange={() => alertActivateSubscriber(cell.row.original.id)}
                        color="primary"
                        name="checkedB"
                        disabled={cell.row.original.status === 1}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />

                </div>,
            }
        ],
        [],
    );

    // Fetch users from the server
    const fetchUsers = async () => {
        setLoading(true);
        var queryString = `page=${pagination.pageIndex}&pageSize=${pagination.pageSize}`;
        if (searchText) {
            queryString += `&email=${searchText}`;
        }

        const request = await axios.get(`${baseUrl()}/calendly-subscribers/list?${queryString}`);
        const { error, total, data } = request.data;
        setLoading(false);
        if (error) {
            toast.error('Error to fetch subscribers');
        } else {
            setUsersList({
                count: total,
                rows: data
            });
        }
    };

    // Handle key down event on search input
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            fetchUsers();
        }
    }

    // Reset account, send the request to the server
    const activateSubscribeAccount = async (account_id: number = 0) => {
        try {
            setLoading(true);
            const request = await axios.get(`/admin/subscriber-calendly-activate/${account_id}`);
            const { error, msg } = request.data;
            if (error) throw new Error(msg);
            setLoading(false);
            fetchUsers();
            toast.success('Subscriber account activated successfully');
        } catch (error: any) {
            setLoading(false);
            util.handleError(error);
        }
    };


    return (
        <>
            <div className='mb-4 row'>
                <div className="col-md-6">
                    <div className="d-flex justify-start align-items-center">
                        <input
                            type={"text"}
                            name="searchText"
                            placeholder="Email"
                            className="form-control w-50"
                            value={searchText}
                            onKeyDown={handleKeyDown}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button type="button" className="btn btn-md btn-custom-secondary ml-2" onClick={fetchUsers}>Search</button>
                    </div>
                </div>
            </div>

            <MaterialReactTable
                columns={columns}
                data={usersList?.rows}
                rowCount={usersList?.count}
                enableColumnOrdering={false}
                enableRowSelection={false}
                enableSelectAll={false}
                enableColumnActions={false}
                manualPagination
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableSorting={false}
                enableGlobalFilter={false}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableHiding={false}
                enableColumnFilters
                enableFilters={false}
            />

            {loadingScreen(loading)}
        </>
    );
}

export default SubscriberContent;